import wordTemplateProcessor from './WordTemplateProcessor';

/**
 * WordPasteSanitizer
 * Sanitizes HTML content pasted from Microsoft Word, Outlook, or other rich text processors.
 * Delegates to WordTemplateProcessor to preserve full table structure, column widths,
 * merged cells (colspan/rowspan), borders, shading, and typography while removing
 * proprietary MSO tags and ensuring strict XSS safety.
 */
export function sanitizeWordHtml(rawHtml) {
  if (!rawHtml || typeof rawHtml !== 'string') return '';
  const result = wordTemplateProcessor.process(rawHtml);
  return result.html;
}

export default sanitizeWordHtml;

